import genererDispositifPublicitaire
  from '@/services/gabed/emplacement/generer/genererDispositifPublicitaire';
import fillDispositifWithData
  from '@/services/import/patrimoine/generation/dispositif/fillDispositifWithData';

export default function generationDispositif(dispositifReference, informationApiReference) {
  const dispositif = genererDispositifPublicitaire();
  dispositif.materiels = [];
  return fillDispositifWithData(dispositifReference, dispositif, informationApiReference);
}
